import { configureStore, Reducer } from "@reduxjs/toolkit";
import { connectRouter, routerMiddleware, RouterState } from "connected-react-router";
import { History } from "history";
import { ApplicationState } from "..";
import { globalApiErrorHandler } from "../api/ErrorHandler";
import { api } from "../api/rtk/BaseApi";
import { reducer as NotificationReducer } from "./notifications/NotificationStore";
import { reducer as SessionReducer } from "./session/SessionStore";

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export type AppThunkAction<TAction> = (dispatch: (action: TAction) => void, getState: () => ApplicationState) => void;

export const configureReduxStore = (history: History) =>
  configureStore({
    reducer: {
      router: connectRouter(history) as Reducer<RouterState>,
      notificationsState: NotificationReducer,
      sessionState: SessionReducer,
      [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // TODO: remove user authenticator from the store
        immutableCheck: {
          ignoredPaths: ["sessionState.userAuthenticator", "sessionState.authClient", "sessionState.appRegistration"],
        },
        // TODO: fix serialization warnings
        serializableCheck: {
          ignoredActionPaths: ["userAuthenticator", "authClient", "meta", "appRegistration"],
          ignoredPaths: ["sessionState.userAuthenticator", "sessionState.authClient", "sessionState.appRegistration"],
          // default is 32 but produces a lot of warnings in screen with 'big' state objects
          warnAfter: 64,
        },
      })
        .concat(routerMiddleware(history))
        .concat(api.middleware)
        .concat(globalApiErrorHandler),
  });
